<template>
<div class="chapter">
<div class="inner_page">
<p class="image-center_tlu1"><span><img alt="image" class="svg" src="Backed/img/tlu-logo.jpg"/></span></p>
<p class="end-title_tlu"><span><b>The Web’s Creepiest Newsletter</b></span></p>
<p class="end-title1_tlu"><span><b>Delivered to Your Inbox</b></span></p>
<p class="tlu-center"><span>Get chilling stories of</span></p>
<p class="tlu-center"><span>true crime, mystery, horror,</span></p>
<p class="tlu-center"><span>and the paranormal,</span></p>
<p class="tlu-center"><span>twice a week.</span></p>
<p class="image-center_tlu"><span><a href="https://the-line-up.com/newsletters/?utm_source=TLUGOAAAAJ&amp;utm_campaign=9781504004817" target="_blank"><img alt="image" class="svg" src="Backed/img/tlu-signup.jpg"/></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tlu_1.vue?7d37202c